import React from "react";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import UsernameInput from "../input/UsernameInput";
import PasswordInput from "../input/PasswordInput";
import BooleanInput from "../input/BooleanInput";
import Button from "../button/Button";

import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./model";

export interface ILoginFormProps {
  api: string;
  title?: string;
  logo?: React.ReactNode;
  usernameLabel?: string;
  passwordLabel?: string;
  loginButtonLabel?: string;
  rememberLabel?: string | null;
  disclosure?: string | React.ReactNode | null;
  trademark?: string | React.ReactNode | null;
}

const LoginForm = (properties: ILoginFormProps) => {
  const defaultProps = {
    usernameLabel: "Username",
    passwordLabel: "Password",
    loginButtonLabel: "Login",
    rememberLabel: "Remember me",
    disclosure: <p>Please authenticate only if you are an authorized user.<br />All requests will logged.</p>,
    trademark: <b>&copy; {(new Date()).getFullYear()} INFOTREND SRL - ITALY</b>
  }
  const props = Object.assign({}, defaultProps, properties);

  const auth = useAuth();
  let navigate = useNavigate();
  let location = useLocation();
  let from = location.state?.from?.pathname || "/";

  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const handlePasswordChange = (p: string) => { console.log(p); setPassword(p); };
  const [remember, setRemember] = React.useState(false);
  const [logable, setLogable] = React.useState(true);

  const [hasError, setHasError] = React.useState(false);
  const handleCloseAlert = () => {
    setHasError(false);
  }

  const handleLoginVerification = () => {
    if (!logable) return;
    const payload = { username, password, remember: false };
    if (props.rememberLabel) payload.remember = remember;
    setHasError(false);
    setLogable(false);
    axios.post(props.api, payload).then(answer => {
      if (answer?.data?.success) {
        //auth.reset();
        const { username, fullname, mail, timeout, avatar, groups, appdata } = answer.data.payload?.user;
        auth.signIn({ username, fullname, mail, timeout, avatar, groups, appdata });
        setTimeout(() => { navigate(from, { replace: true }); }, 100);
      } else {
        throw new Error("Login request failed!");
      };
    }).catch(() => {
      setLogable(true);
      setHasError(true);
    });
  };

  const handleKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 13) handleLoginVerification();
  }

  return (
    <Container maxWidth="xs" sx={{ mt: 5 }}><form>
      <Grid container spacing={2}>
        {
          props.title ?
            <Grid xs={12}>
              <Box sx={{ minWidth: 1, p: 1 }}>
                <h3>{props.title}</h3>
              </Box>
            </Grid> :
            null
        }
        {
          props.logo ?
            <Grid xs={12}>
              <Box sx={{ minWidth: 1, bgcolor: "primary.main", p: 1 }}>
                {props.logo}
              </Box>
            </Grid> :
            null
        }
        <Grid xs={12}>
          <UsernameInput label={props.usernameLabel || "Username"} value={username} onChange={setUsername} disabled={!logable} onKeyDown={handleKeydown} />
        </Grid>
        <Grid xs={12}>
          <PasswordInput label={props.passwordLabel || "Password"} value={password} onChange={setPassword} disabled={!logable} onKeyDown={handleKeydown} />
        </Grid>

        <Grid xs={12}>
          <Box sx={{ textAlign: "center" }}>
            <Button label={props.loginButtonLabel || "Login"} onClick={handleLoginVerification} disabled={!logable} />
          </Box>
        </Grid>

        {
          props.rememberLabel ?
            <Grid xs={12} >
              <Box sx={{ float: "right" }}>
                <BooleanInput label={props.rememberLabel || "Remeber me"} value={remember} onChange={setRemember} swapLabel={true} />
              </Box>
            </Grid> :
            null
        }

        {
          props.disclosure ?
            <Grid xs={12}>
              <Box sx={{ minWidth: 1, mt: 1, textAlign: 'center' }}>
                <small>{props.disclosure}</small>
              </Box>
            </Grid> :
            null
        }
        {
          props.trademark ?
            <Grid xs={12}>
              <Box sx={{ minWidth: 1, mt: (props.disclosure ? -1 : 1), textAlign: 'center' }}>
                <small>{props.trademark}</small>
              </Box>
            </Grid> :
            null
        }

      </Grid>

      <Snackbar open={hasError} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>
          An error has occured on login: may username or password wrong?
        </Alert>
      </Snackbar>
      </form></Container >
  );
};

export default LoginForm;